webpackJsonp([275267278196080],{

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/divider4.c64873de.jpg";

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(40);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _sortBy = __webpack_require__(44);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _reactHelmet = __webpack_require__(49);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _divider = __webpack_require__(180);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderComplete = function (_React$Component) {
	  _inherits(HeaderComplete, _React$Component);
	
	  function HeaderComplete() {
	    _classCallCheck(this, HeaderComplete);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  HeaderComplete.prototype.render = function render() {
	    // console.log("props", this.props)
	    // const pageLinks = []
	    // const site = get(this, 'props.data.site.siteMetadata')
	    return _react2.default.createElement(
	      'div',
	      { id: 'headerwrap', name: 'home', style: { backgroundImage: 'url(' + _divider2.default + ')' } },
	      _react2.default.createElement(
	        'header',
	        { className: 'clearfix' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement('span', { className: 'icon icon-w' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Christian Wolter'
	        )
	      )
	    );
	  };
	
	  return HeaderComplete;
	}(_react2.default.Component);
	
	var Footer = function (_React$Component2) {
	  _inherits(Footer, _React$Component2);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    var _this2 = _possibleConstructorReturn(this, _React$Component2.call(this));
	
	    _this2.state = {
	      intervalId: 0
	    };
	    return _this2;
	  }
	
	  Footer.prototype.scrollStep = function scrollStep() {
	    if (window.pageYOffset === 0) {
	      clearInterval(this.state.intervalId);
	    }
	    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
	  };
	
	  Footer.prototype.scrollToTop = function scrollToTop() {
	    var intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
	    this.setState({ intervalId: intervalId });
	  };
	
	  Footer.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { id: 'footerwrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(
	              'small',
	              null,
	              'created by Christian Wolter - copyright 2017 - ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/imprint', onClick: function onClick() {
	                    _this3.scrollToTop();
	                  } },
	                'imprint | disclaimer'
	              ),
	              ' -  ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/privacy', onClick: function onClick() {
	                    _this3.scrollToTop();
	                  } },
	                'privacy'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react2.default.Component);
	
	var ScrollButton = function (_React$Component3) {
	  _inherits(ScrollButton, _React$Component3);
	
	  function ScrollButton() {
	    _classCallCheck(this, ScrollButton);
	
	    var _this4 = _possibleConstructorReturn(this, _React$Component3.call(this));
	
	    _this4.state = {
	      intervalId: 0
	    };
	    return _this4;
	  }
	
	  ScrollButton.prototype.scrollStep = function scrollStep() {
	    if (window.pageYOffset === 0) {
	      clearInterval(this.state.intervalId);
	    }
	    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
	  };
	
	  ScrollButton.prototype.scrollToTop = function scrollToTop() {
	    var intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
	    this.setState({ intervalId: intervalId });
	  };
	
	  ScrollButton.prototype.render = function render() {
	    var _this5 = this;
	
	    return _react2.default.createElement(
	      'button',
	      { title: 'Back to top', className: 'scroll',
	        onClick: function onClick() {
	          _this5.scrollToTop();
	        } },
	      _react2.default.createElement('span', { className: 'arrow-up glyphicon glyphicon-chevron-up' })
	    );
	  };
	
	  return ScrollButton;
	}(_react2.default.Component);
	
	var Projects = function (_React$Component4) {
	  _inherits(Projects, _React$Component4);
	
	  function Projects() {
	    _classCallCheck(this, Projects);
	
	    return _possibleConstructorReturn(this, _React$Component4.apply(this, arguments));
	  }
	
	  Projects.prototype.render = function render() {
	    var pathPrefix =  false ? '' : ("");
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(HeaderComplete, null),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'container', id: 'impressum', name: 'impressum' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'h1',
	              { className: 'centered' },
	              'privacy policy'
	            ),
	            _react2.default.createElement('hr', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'Datenschutzerkl\xE4rung'
	                ),
	                _react2.default.createElement('h3', { id: 'dsg-general-intro' }),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Diese Datenschutzerkl\xE4rung kl\xE4rt Sie \xFCber die Art, den Umfang und Zweck der Verarbeitung von personenbezogenen Daten (nachfolgend kurz \u201EDaten\u201C) innerhalb unseres Onlineangebotes und der mit ihm verbundenen Webseiten, Funktionen und Inhalte sowie externen Onlinepr\xE4senzen, wie z.B. unser Social Media Profile auf (nachfolgend gemeinsam bezeichnet als \u201EOnlineangebot\u201C). Im Hinblick auf die verwendeten Begrifflichkeiten, wie z.B. \u201EVerarbeitung\u201C oder \u201EVerantwortlicher\u201C verweisen wir auf die Definitionen im Art. 4 der Datenschutzgrundverordnung (DSGVO).',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-general-controller' },
	                  'Verantwortlicher'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'tsmcontroller' },
	                    'Christian Wolter',
	                    _react2.default.createElement('br', null),
	                    'Peterstr. 54',
	                    _react2.default.createElement('br', null),
	                    '90478 N\xFCrnberg',
	                    _react2.default.createElement('br', null),
	                    'contact@christian-wolter.com',
	                    _react2.default.createElement('br', null),
	                    'Link zum Impressum: http://www.christian-wolter.com/imprint',
	                    _react2.default.createElement('br', null)
	                  )
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-general-datatype' },
	                  'Arten der verarbeiteten Daten:'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '- Nutzungsdaten (z.B., besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten).',
	                  _react2.default.createElement('br', null),
	                  '- Meta-/Kommunikationsdaten (z.B., Ger\xE4te-Informationen, IP-Adressen).',
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-general-datasubjects' },
	                  'Kategorien betroffener Personen'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Besucher und Nutzer des Onlineangebotes (Nachfolgend bezeichnen wir die betroffenen Personen zusammenfassend auch als \u201ENutzer\u201C).',
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-general-purpose' },
	                  'Zweck der Verarbeitung'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '- Zurverf\xFCgungstellung des Onlineangebotes, seiner Funktionen und  Inhalte.',
	                  _react2.default.createElement('br', null),
	                  '- Beantwortung von Kontaktanfragen und Kommunikation mit Nutzern.',
	                  _react2.default.createElement('br', null),
	                  '- Sicherheitsma\xDFnahmen.',
	                  _react2.default.createElement('br', null),
	                  '- Reichweitenmessung/Marketing',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('span', { className: 'tsmcom' })
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-general-terms' },
	                  'Verwendete Begrifflichkeiten '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '\u201EPersonenbezogene Daten\u201C sind alle Informationen, die sich auf eine identifizierte oder identifizierbare nat\xFCrliche Person (im Folgenden \u201Ebetroffene Person\u201C) beziehen; als identifizierbar wird eine nat\xFCrliche Person angesehen, die direkt oder indirekt, insbesondere mittels Zuordnung zu einer Kennung wie einem Namen, zu einer Kennnummer, zu Standortdaten, zu einer Online-Kennung (z.B. Cookie) oder zu einem oder mehreren besonderen Merkmalen identifiziert werden kann, die Ausdruck der physischen, physiologischen, genetischen, psychischen, wirtschaftlichen, kulturellen oder sozialen Identit\xE4t dieser nat\xFCrlichen Person sind.',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  '\u201EVerarbeitung\u201C ist jeder mit oder ohne Hilfe automatisierter Verfahren ausgef\xFChrte Vorgang oder jede solche Vorgangsreihe im Zusammenhang mit personenbezogenen Daten. Der Begriff reicht weit und umfasst praktisch jeden Umgang mit Daten.',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  '\u201EPseudonymisierung\u201C die Verarbeitung personenbezogener Daten in einer Weise, dass die personenbezogenen Daten ohne Hinzuziehung zus\xE4tzlicher Informationen nicht mehr einer spezifischen betroffenen Person zugeordnet werden k\xF6nnen, sofern diese zus\xE4tzlichen Informationen gesondert aufbewahrt werden und technischen und organisatorischen Ma\xDFnahmen unterliegen, die gew\xE4hrleisten, dass die personenbezogenen Daten nicht einer identifizierten oder identifizierbaren nat\xFCrlichen Person zugewiesen werden.',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  '\u201EProfiling\u201C jede Art der automatisierten Verarbeitung personenbezogener Daten, die darin besteht, dass diese personenbezogenen Daten verwendet werden, um bestimmte pers\xF6nliche Aspekte, die sich auf eine nat\xFCrliche Person beziehen, zu bewerten, insbesondere um Aspekte bez\xFCglich Arbeitsleistung, wirtschaftliche Lage, Gesundheit, pers\xF6nliche Vorlieben, Interessen, Zuverl\xE4ssigkeit, Verhalten, Aufenthaltsort oder Ortswechsel dieser nat\xFCrlichen Person zu analysieren oder vorherzusagen.',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  'Als \u201EVerantwortlicher\u201C wird die nat\xFCrliche oder juristische Person, Beh\xF6rde, Einrichtung oder andere Stelle, die allein oder gemeinsam mit anderen \xFCber die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet, bezeichnet.',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  '\u201EAuftragsverarbeiter\u201C eine nat\xFCrliche oder juristische Person, Beh\xF6rde, Einrichtung oder andere Stelle, die personenbezogene Daten im Auftrag des Verantwortlichen verarbeitet.',
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-general-legalbasis' },
	                  'Ma\xDFgebliche Rechtsgrundlagen'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Nach Ma\xDFgabe des Art. 13 DSGVO teilen wir Ihnen die Rechtsgrundlagen unserer Datenverarbeitungen mit. Sofern die Rechtsgrundlage in der Datenschutzerkl\xE4rung nicht genannt wird, gilt Folgendes: Die Rechtsgrundlage f\xFCr die Einholung von Einwilligungen ist Art. 6 Abs. 1 lit. a und Art. 7 DSGVO, die Rechtsgrundlage f\xFCr die Verarbeitung zur Erf\xFCllung unserer Leistungen und Durchf\xFChrung vertraglicher Ma\xDFnahmen sowie Beantwortung von Anfragen ist Art. 6 Abs. 1 lit. b DSGVO, die Rechtsgrundlage f\xFCr die Verarbeitung zur Erf\xFCllung unserer rechtlichen Verpflichtungen ist Art. 6 Abs. 1 lit. c DSGVO, und die Rechtsgrundlage f\xFCr die Verarbeitung zur Wahrung unserer berechtigten Interessen ist Art. 6 Abs. 1 lit. f DSGVO. F\xFCr den Fall, dass lebenswichtige Interessen der betroffenen Person oder einer anderen nat\xFCrlichen Person eine Verarbeitung personenbezogener Daten erforderlich machen, dient Art. 6 Abs. 1 lit. d DSGVO als Rechtsgrundlage.'
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-general-securitymeasures' },
	                  'Sicherheitsma\xDFnahmen'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Wir treffen nach Ma\xDFgabe des Art. 32 DSGVO unter Ber\xFCcksichtigung des Stands der Technik, der Implementierungskosten und der Art, des Umfangs, der Umst\xE4nde und der Zwecke der Verarbeitung sowie der unterschiedlichen Eintrittswahrscheinlichkeit und Schwere des Risikos f\xFCr die Rechte und Freiheiten nat\xFCrlicher Personen, geeignete technische und organisatorische Ma\xDFnahmen, um ein dem Risiko angemessenes Schutzniveau zu gew\xE4hrleisten.',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  'Zu den Ma\xDFnahmen geh\xF6ren insbesondere die Sicherung der Vertraulichkeit, Integrit\xE4t und Verf\xFCgbarkeit von Daten durch Kontrolle des physischen Zugangs zu den Daten, als auch des sie betreffenden Zugriffs, der Eingabe, Weitergabe, der Sicherung der Verf\xFCgbarkeit und ihrer Trennung. Des Weiteren haben wir Verfahren eingerichtet, die eine Wahrnehmung von Betroffenenrechten, L\xF6schung von Daten und Reaktion auf Gef\xE4hrdung der Daten gew\xE4hrleisten. Ferner ber\xFCcksichtigen wir den Schutz personenbezogener Daten bereits bei der Entwicklung, bzw. Auswahl von Hardware, Software sowie Verfahren, entsprechend dem Prinzip des Datenschutzes durch Technikgestaltung und durch datenschutzfreundliche Voreinstellungen (Art. 25 DSGVO).',
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-general-coprocessing' },
	                  'Zusammenarbeit mit Auftragsverarbeitern und Dritten'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Sofern wir im Rahmen unserer Verarbeitung Daten gegen\xFCber anderen Personen und Unternehmen (Auftragsverarbeitern oder Dritten) offenbaren, sie an diese \xFCbermitteln oder ihnen sonst Zugriff auf die Daten gew\xE4hren, erfolgt dies nur auf Grundlage einer gesetzlichen Erlaubnis (z.B. wenn eine \xDCbermittlung der Daten an Dritte, wie an Zahlungsdienstleister, gem. Art. 6 Abs. 1 lit. b DSGVO zur Vertragserf\xFCllung erforderlich ist), Sie eingewilligt haben, eine rechtliche Verpflichtung dies vorsieht oder auf Grundlage unserer berechtigten Interessen (z.B. beim Einsatz von Beauftragten, Webhostern, etc.). ',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  'Sofern wir Dritte mit der Verarbeitung von Daten auf Grundlage eines sog. \u201EAuftragsverarbeitungsvertrages\u201C beauftragen, geschieht dies auf Grundlage des Art. 28 DSGVO.'
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-general-thirdparty' },
	                  '\xDCbermittlungen in Drittl\xE4nder'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Sofern wir Daten in einem Drittland (d.h. au\xDFerhalb der Europ\xE4ischen Union (EU) oder des Europ\xE4ischen Wirtschaftsraums (EWR)) verarbeiten oder dies im Rahmen der Inanspruchnahme von Diensten Dritter oder Offenlegung, bzw. \xDCbermittlung von Daten an Dritte geschieht, erfolgt dies nur, wenn es zur Erf\xFCllung unserer (vor)vertraglichen Pflichten, auf Grundlage Ihrer Einwilligung, aufgrund einer rechtlichen Verpflichtung oder auf Grundlage unserer berechtigten Interessen geschieht. Vorbehaltlich gesetzlicher oder vertraglicher Erlaubnisse, verarbeiten oder lassen wir die Daten in einem Drittland nur beim Vorliegen der besonderen Voraussetzungen der Art. 44 ff. DSGVO verarbeiten. D.h. die Verarbeitung erfolgt z.B. auf Grundlage besonderer Garantien, wie der offiziell anerkannten Feststellung eines der EU entsprechenden Datenschutzniveaus (z.B. f\xFCr die USA durch das \u201EPrivacy Shield\u201C) oder Beachtung offiziell anerkannter spezieller vertraglicher Verpflichtungen (so genannte \u201EStandardvertragsklauseln\u201C).'
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-general-rightssubject' },
	                  'Rechte der betroffenen Personen'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Sie haben das Recht, eine Best\xE4tigung dar\xFCber zu verlangen, ob betreffende Daten verarbeitet werden und auf Auskunft \xFCber diese Daten sowie auf weitere Informationen und Kopie der Daten entsprechend Art. 15 DSGVO.',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  'Sie haben entsprechend. Art. 16 DSGVO das Recht, die Vervollst\xE4ndigung der Sie betreffenden Daten oder die Berichtigung der Sie betreffenden unrichtigen Daten zu verlangen.',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  'Sie haben nach Ma\xDFgabe des Art. 17 DSGVO das Recht zu verlangen, dass betreffende Daten unverz\xFCglich gel\xF6scht werden, bzw. alternativ nach Ma\xDFgabe des Art. 18 DSGVO eine Einschr\xE4nkung der Verarbeitung der Daten zu verlangen.',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  'Sie haben das Recht zu verlangen, dass die Sie betreffenden Daten, die Sie uns bereitgestellt haben nach Ma\xDFgabe des Art. 20 DSGVO zu erhalten und deren \xDCbermittlung an andere Verantwortliche zu fordern. ',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  'Sie haben ferner gem. Art. 77 DSGVO das Recht, eine Beschwerde bei der zust\xE4ndigen Aufsichtsbeh\xF6rde einzureichen.'
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-general-revokeconsent' },
	                  'Widerrufsrecht'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Sie haben das Recht, erteilte Einwilligungen gem. Art. 7 Abs. 3 DSGVO mit Wirkung f\xFCr die Zukunft zu widerrufen'
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-general-object' },
	                  'Widerspruchsrecht'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Sie k\xF6nnen der k\xFCnftigen Verarbeitung der Sie betreffenden Daten nach Ma\xDFgabe des Art. 21 DSGVO jederzeit widersprechen. Der Widerspruch kann insbesondere gegen die Verarbeitung f\xFCr Zwecke der Direktwerbung erfolgen.'
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-general-cookies' },
	                  'Cookies und Widerspruchsrecht bei Direktwerbung'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Als \u201ECookies\u201C werden kleine Dateien bezeichnet, die auf Rechnern der Nutzer gespeichert werden. Innerhalb der Cookies k\xF6nnen unterschiedliche Angaben gespeichert werden. Ein Cookie dient prim\xE4r dazu, die Angaben zu einem Nutzer (bzw. dem Ger\xE4t auf dem das Cookie gespeichert ist) w\xE4hrend oder auch nach seinem Besuch innerhalb eines Onlineangebotes zu speichern. Als tempor\xE4re Cookies, bzw. \u201ESession-Cookies\u201C oder \u201Etransiente Cookies\u201C, werden Cookies bezeichnet, die gel\xF6scht werden, nachdem ein Nutzer ein Onlineangebot verl\xE4sst und seinen Browser schlie\xDFt. In einem solchen Cookie kann z.B. der Inhalt eines Warenkorbs in einem Onlineshop oder ein Login-Status gespeichert werden. Als \u201Epermanent\u201C oder \u201Epersistent\u201C werden Cookies bezeichnet, die auch nach dem Schlie\xDFen des Browsers gespeichert bleiben. So kann z.B. der Login-Status gespeichert werden, wenn die Nutzer diese nach mehreren Tagen aufsuchen. Ebenso k\xF6nnen in einem solchen Cookie die Interessen der Nutzer gespeichert werden, die f\xFCr Reichweitenmessung oder Marketingzwecke verwendet werden. Als \u201EThird-Party-Cookie\u201C werden Cookies bezeichnet, die von anderen Anbietern als dem Verantwortlichen, der das Onlineangebot betreibt, angeboten werden (andernfalls, wenn es nur dessen Cookies sind spricht man von \u201EFirst-Party Cookies\u201C).',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  'Wir k\xF6nnen tempor\xE4re und permanente Cookies einsetzen und kl\xE4ren hier\xFCber im Rahmen unserer Datenschutzerkl\xE4rung auf.',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  'Falls die Nutzer nicht m\xF6chten, dass Cookies auf ihrem Rechner gespeichert werden, werden sie gebeten die entsprechende Option in den Systemeinstellungen ihres Browsers zu deaktivieren. Gespeicherte Cookies k\xF6nnen in den Systemeinstellungen des Browsers gel\xF6scht werden. Der Ausschluss von Cookies kann zu Funktionseinschr\xE4nkungen dieses Onlineangebotes f\xFChren.',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  'Ein genereller Widerspruch gegen den Einsatz der zu Zwecken des Onlinemarketing eingesetzten Cookies kann bei einer Vielzahl der Dienste, vor allem im Fall des Trackings, \xFCber die US-amerikanische Seite ',
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'http://www.aboutads.info/choices/' },
	                    'http://www.aboutads.info/choices/'
	                  ),
	                  ' oder die EU-Seite ',
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'http://www.youronlinechoices.com/' },
	                    'http://www.youronlinechoices.com/'
	                  ),
	                  ' erkl\xE4rt werden. Des Weiteren kann die Speicherung von Cookies mittels deren Abschaltung in den Einstellungen des Browsers erreicht werden. Bitte beachten Sie, dass dann gegebenenfalls nicht alle Funktionen dieses Onlineangebotes genutzt werden k\xF6nnen.'
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-general-erasure' },
	                  'L\xF6schung von Daten'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Die von uns verarbeiteten Daten werden nach Ma\xDFgabe der Art. 17 und 18 DSGVO gel\xF6scht oder in ihrer Verarbeitung eingeschr\xE4nkt. Sofern nicht im Rahmen dieser Datenschutzerkl\xE4rung ausdr\xFCcklich angegeben, werden die bei uns gespeicherten Daten gel\xF6scht, sobald sie f\xFCr ihre Zweckbestimmung nicht mehr erforderlich sind und der L\xF6schung keine gesetzlichen Aufbewahrungspflichten entgegenstehen. Sofern die Daten nicht gel\xF6scht werden, weil sie f\xFCr andere und gesetzlich zul\xE4ssige Zwecke erforderlich sind, wird deren Verarbeitung eingeschr\xE4nkt. D.h. die Daten werden gesperrt und nicht f\xFCr andere Zwecke verarbeitet. Das gilt z.B. f\xFCr Daten, die aus handels- oder steuerrechtlichen Gr\xFCnden aufbewahrt werden m\xFCssen.',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  'Nach gesetzlichen Vorgaben in Deutschland, erfolgt die Aufbewahrung insbesondere f\xFCr 10 Jahre gem\xE4\xDF \xA7\xA7 147 Abs. 1 AO, 257 Abs. 1 Nr. 1 und 4, Abs. 4 HGB (B\xFCcher, Aufzeichnungen, Lageberichte, Buchungsbelege, Handelsb\xFCcher, f\xFCr Besteuerung relevanter Unterlagen, etc.) und 6 Jahre gem\xE4\xDF \xA7 257 Abs. 1 Nr. 2 und 3, Abs. 4 HGB (Handelsbriefe). ',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  'Nach gesetzlichen Vorgaben in \xD6sterreich erfolgt die Aufbewahrung insbesondere f\xFCr 7 J gem\xE4\xDF \xA7 132 Abs. 1 BAO (Buchhaltungsunterlagen, Belege/Rechnungen, Konten, Belege, Gesch\xE4ftspapiere, Aufstellung der Einnahmen und Ausgaben, etc.), f\xFCr 22 Jahre im Zusammenhang mit Grundst\xFCcken und f\xFCr 10 Jahre bei Unterlagen im Zusammenhang mit elektronisch erbrachten Leistungen, Telekommunikations-, Rundfunk- und Fernsehleistungen, die an Nichtunternehmer in EU-Mitgliedstaaten erbracht werden und f\xFCr die der Mini-One-Stop-Shop (MOSS) in Anspruch genommen wird.'
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-hostingprovider' },
	                  'Hosting und E-Mail-Versand'
	                ),
	                _react2.default.createElement('p', null),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ts-muster-content' },
	                  'Die von uns in Anspruch genommenen Hosting-Leistungen dienen der Zurverf\xFCgungstellung der folgenden Leistungen: Infrastruktur- und Plattformdienstleistungen, Rechenkapazit\xE4t, Speicherplatz und Datenbankdienste, E-Mail-Versand, Sicherheitsleistungen sowie technische Wartungsleistungen, die wir zum Zwecke des Betriebs dieses Onlineangebotes einsetzen. ',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  'Hierbei verarbeiten wir, bzw. unser Hostinganbieter Bestandsdaten, Kontaktdaten, Inhaltsdaten, Vertragsdaten, Nutzungsdaten, Meta- und Kommunikationsdaten von Kunden, Interessenten und Besuchern dieses Onlineangebotes auf Grundlage unserer berechtigten Interessen an einer effizienten und sicheren Zurverf\xFCgungstellung dieses Onlineangebotes gem. Art. 6 Abs. 1 lit. f DSGVO i.V.m. Art. 28 DSGVO (Abschluss Auftragsverarbeitungsvertrag).'
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-socialmedia' },
	                  'Onlinepr\xE4senzen in sozialen Medien'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'ts-muster-content' },
	                    'Wir unterhalten Onlinepr\xE4senzen innerhalb sozialer Netzwerke und Plattformen, um mit den dort aktiven Kunden, Interessenten und Nutzern kommunizieren und sie dort \xFCber unsere Leistungen informieren zu k\xF6nnen. Beim Aufruf der jeweiligen Netzwerke und Plattformen gelten die Gesch\xE4ftsbedingungen und die Datenverarbeitungsrichtlinien deren jeweiligen Betreiber.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    'Soweit nicht anders im Rahmen unserer Datenschutzerkl\xE4rung angegeben, verarbeiten wir die Daten der Nutzer sofern diese mit uns innerhalb der sozialen Netzwerke und Plattformen kommunizieren, z.B. Beitr\xE4ge auf unseren Onlinepr\xE4senzen verfassen oder uns Nachrichten zusenden.'
	                  )
	                ),
	                _react2.default.createElement('p', null),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-thirdparty-einleitung' },
	                  'Einbindung von Diensten und Inhalten Dritter'
	                ),
	                _react2.default.createElement('p', null),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'ts-muster-content' },
	                    'Wir setzen innerhalb unseres Onlineangebotes auf Grundlage unserer berechtigten Interessen (d.h. Interesse an der Analyse, Optimierung und wirtschaftlichem Betrieb unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO) Inhalts- oder Serviceangebote von Drittanbietern ein, um deren Inhalte und Services, wie z.B. Videos oder Schriftarten einzubinden (nachfolgend einheitlich bezeichnet als \u201CInhalte\u201D). ',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    'Dies setzt immer voraus, dass die Drittanbieter dieser Inhalte, die IP-Adresse der Nutzer wahrnehmen, da sie ohne die IP-Adresse die Inhalte nicht an deren Browser senden k\xF6nnten. Die IP-Adresse ist damit f\xFCr die Darstellung dieser Inhalte erforderlich. Wir bem\xFChen uns nur solche Inhalte zu verwenden, deren jeweilige Anbieter die IP-Adresse lediglich zur Auslieferung der Inhalte verwenden. Drittanbieter k\xF6nnen ferner so genannte Pixel-Tags (unsichtbare Grafiken, auch als "Web Beacons" bezeichnet) f\xFCr statistische oder Marketingzwecke verwenden. Durch die "Pixel-Tags" k\xF6nnen Informationen, wie der Besucherverkehr auf den Seiten dieser Website ausgewertet werden. Die pseudonymen Informationen k\xF6nnen ferner in Cookies auf dem Ger\xE4t der Nutzer gespeichert werden und unter anderem technische Informationen zum Browser und Betriebssystem, verweisende Webseiten, Besuchszeit sowie weitere Angaben zur Nutzung unseres Onlineangebotes enthalten, als auch mit solchen Informationen aus anderen Quellen verbunden werden.'
	                  )
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-thirdparty-googlefonts' },
	                  'Google Fonts'
	                ),
	                _react2.default.createElement('p', null),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ts-muster-content' },
	                  'Wir binden die Schriftarten ("Google Fonts") des Anbieters Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA, ein. Datenschutzerkl\xE4rung: ',
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://www.google.com/policies/privacy/' },
	                    'https://www.google.com/policies/privacy/'
	                  ),
	                  ', Opt-Out: ',
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://adssettings.google.com/authenticated' },
	                    'https://adssettings.google.com/authenticated'
	                  ),
	                  '.'
	                ),
	                _react2.default.createElement('p', null),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-thirdparty-twitter' },
	                  'Twitter'
	                ),
	                _react2.default.createElement('p', null),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ts-muster-content' },
	                  'Innerhalb unseres Onlineangebotes k\xF6nnen Funktionen und Inhalte des Dienstes Twitter, angeboten durch die Twitter Inc., 1355 Market Street, Suite 900, San Francisco, CA 94103, USA, eingebunden werden. Hierzu k\xF6nnen z.B. Inhalte wie Bilder, Videos oder Texte und Schaltfl\xE4chen geh\xF6ren, mit denen Nutzer Inhalte dieses Onlineangebotes innerhalb von Twitter teilen k\xF6nnen.',
	                  _react2.default.createElement('br', null),
	                  'Sofern die Nutzer Mitglieder der Plattform Twitter sind, kann Twitter den Aufruf der o.g. Inhalte und Funktionen den dortigen Profilen der Nutzer zuordnen. Twitter ist unter dem Privacy-Shield-Abkommen zertifiziert und bietet hierdurch eine Garantie, das europ\xE4ische Datenschutzrecht einzuhalten (',
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://www.privacyshield.gov/participant?id=a2zt0000000TORzAAO&status=Active' },
	                    'https://www.privacyshield.gov/participant?id=a2zt0000000TORzAAO&status=Active'
	                  ),
	                  '). Datenschutzerkl\xE4rung: ',
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://twitter.com/de/privacy' },
	                    'https://twitter.com/de/privacy'
	                  ),
	                  ', Opt-Out: ',
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://twitter.com/personalization' },
	                    'https://twitter.com/personalization'
	                  ),
	                  '.'
	                ),
	                _react2.default.createElement('p', null),
	                _react2.default.createElement(
	                  'h3',
	                  { id: 'dsg-thirdparty-linkedin' },
	                  'LinkedIn'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'ts-muster-content' },
	                    'Innerhalb unseres Onlineangebotes k\xF6nnen Funktionen und Inhalte des Dienstes LinkedIn, angeboten durch die inkedIn Ireland Unlimited Company Wilton Place, Dublin 2, Irland, eingebunden werden. Hierzu k\xF6nnen z.B. Inhalte wie Bilder, Videos oder Texte und Schaltfl\xE4chen geh\xF6ren, mit denen Nutzer Inhalte dieses Onlineangebotes innerhalb von LinkedIn teilen k\xF6nnen. Sofern die Nutzer Mitglieder der Plattform LinkedIn sind, kann LinkedIn den Aufruf der o.g. Inhalte und Funktionen den dortigen Profilen der Nutzer zuordnen. Datenschutzerkl\xE4rung von LinkedIn: ',
	                    _react2.default.createElement(
	                      'a',
	                      { target: '_blank', href: 'https://www.linkedin.com/legal/privacy-policy' },
	                      'https://www.linkedin.com/legal/privacy-policy.'
	                    ),
	                    '. LinkedIn ist unter dem Privacy-Shield-Abkommen zertifiziert und bietet hierdurch eine Garantie, das europ\xE4ische Datenschutzrecht einzuhalten (',
	                    _react2.default.createElement(
	                      'a',
	                      { target: '_blank', href: 'https://www.privacyshield.gov/participant?id=a2zt0000000L0UZAA0&status=Active' },
	                      'https://www.privacyshield.gov/participant?id=a2zt0000000L0UZAA0&status=Active'
	                    ),
	                    '). Datenschutzerkl\xE4rung: ',
	                    _react2.default.createElement(
	                      'a',
	                      { target: '_blank', href: 'https://www.linkedin.com/legal/privacy-policy' },
	                      'https://www.linkedin.com/legal/privacy-policy'
	                    ),
	                    ', Opt-Out: ',
	                    _react2.default.createElement(
	                      'a',
	                      { target: '_blank', href: 'https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out' },
	                      'https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out'
	                    ),
	                    '.'
	                  )
	                ),
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://datenschutz-generator.de', className: 'dsg1-5', rel: 'nofollow', target: '_blank' },
	                  'Erstellt mit Datenschutz-Generator.de von RA Dr. Thomas Schwenke'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(ScrollButton, { scrollStepInPx: '50', delayInMs: '16.66' }),
	      _react2.default.createElement(Footer, null)
	    );
	  };
	
	  return Projects;
	}(_react2.default.Component);
	
	exports.default = Projects;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-index-jsx-d9bef952f44b2dbc2bf9.js